//  $(window).scroll(function(){
//   var sticky = $('.product-details .sharing.social-links'),
//       scroll = $(window).scrollTop();

//   if (scroll >= 100) sticky.addClass('fixed');
//   else sticky.removeClass('fixed');
// });
function add_qty(){
  setTimeout(function(){
    var iuy=$('div#qty_atc input[type=number]').val();
    
    $('.qty-adjuster input#quantity').val(iuy)
  },100)
}

$('.sticky_bar_atc .add').click(function () {
		 add_qty()
    	$(this).prev().val(+$(this).prev().val() + 1);
		 
});
$('.sticky_bar_atc .sub').click(function () {
  add_qty()
		if ($(this).next().val() > 1) {
    	if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
		}
});
if($('body').hasClass('template-product')){
var distance = $('.product-details .sharing.social-links').offset().top - 200,
    $window = $(window);

$window.scroll(function() {
 

    if ( $window.scrollTop() >= distance ) {
       $('body').addClass('fixed_atc')
    }else{
        $('body').removeClass('fixed_atc')
    }
});
}

$("body").on("click", ".product-form.product-form--main .qty-adjuster .qty-adjuster__down,.product-form.product-form--main .qty-adjuster .qty-adjuster__up", function(event){

 setTimeout(function(){
    var iuy=$('.qty-adjuster input#quantity').val()
      
   $('div#qty_atc input[type=number]').val(iuy);
    
    
  },100)

})
$("body").on("click", ".parent_atc .add_cart", function(event){
var prcs=$(this).attr('prcs');
  $('.parent_atc .add_cart').text(prcs)

  var avl=$(this).attr('avl'); 
setTimeout(function(){
   $('.parent_atc .add_cart').text(avl)
},1500)
  $('.product-form .payment-and-quantity--buttons-active .payment-and-quantity__add .product-add').trigger('click')

})
$("body").on("click", ".aacro_faq h3", function(event){


 if($(this).hasClass('active')){
      $(".aacro_faq h3").removeClass('active')
 $('.asw-faq').slideUp()
   
 }else{
   $(".aacro_faq h3").removeClass('active')
 $('.asw-faq').slideUp()
  $(this).addClass('active')
 $(this).next('.asw-faq').slideDown() 
 }
  })
 
$(document).mouseup(function(e) 
{
    var container = $(".active_team  .continaer.inter_pp");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
       $('body').removeClass('active_team')
    }
});
$('.athimg span.close').click(function () {
$('body').removeClass('active_team')


})
$('span.readess_teams').click(function () {
   var that=$(this)
that.parent().slideUp()
    that.parent().prev().slideDown()


})
$('span.read_teams').click(function () {
  console.log('test')
 var that=$(this)
    if ($(window).width() < 767)
    {
  setTimeout(function(){

that.parent().slideUp()
    that.parent().next().slideDown()
  },100)
    }else{
 
  setTimeout(function(){
    
$('body').addClass('active_team')
 var head=that.parent().parent().parent().find('.herro_sym_area h2').text();
   
   var abt=that.parent().parent().parent().find('.herro_sym_area p').text();
   var desc=that.parent().parent().parent().find('.fulldesc').html();
    var imgsrc=that.parent().parent().parent().find('.herro_sym_img img').attr('src');
$('.abt_team').html(desc)
$('.right_team .abt h2').text(head)
  $('.right_team .abt p').text(abt)
  $('.continaer.inter_pp .athimg img').attr('src',imgsrc)
  
  },100)
    }
})
function sniptoffer(){
  if($('.product-details .revy-bundle-action').hasClass('added_snipt')){}else{
  $('.product-details .revy-bundle-action').addClass('added_snipt');
$('<h3 class="top_heading">Tier pricing applied at check out</h3><div class="get_off"></div>').insertBefore('.product-details div#revy-bundles-wrapper')
     var pris=$('div#price span.current-price.theme-money').text().replace("$", "");
  
   $('.get_off').append('<div class="row_offer"><div class="qty_buy">Buy 1 </div><div class="ec_prc">$'+pris+' each </div></div>')
 
  $('.product-details .revy-bundle-action button').each(function(){
  var gtmn=$(this).find('span.revy-bundle-button-line.first span.revy-bundle-text-variable').text();
  var gtp=$(this).find('span.revy-bundle-button-line.second span.revy-bundle-text-variable').text().replace("%", "");
  
   
    var nepric=pris*gtp/100
    var iys=pris - nepric
     
    

    $('.get_off').append('<div class="row_offer"><div class="qty_buy">Buy '+gtmn+'	</div><div class="ec_prc">$'+iys.toFixed(2)+' each </div></div>')
  })
  }
}
  sniptoffer()
$(window).on('load', function() {
  sniptoffer();
  setTimeout(function(){
    sniptoffer()
  },100)

  setTimeout(function(){
    sniptoffer()
  },1000)
})

if($('body').hasClass('template-sfx-contact')){
  $(window).on('load', function() {
setTimeout(function(){
  
    if (window.location.href.indexOf("=true#contact_form") > -1) {
       if ($(window).width() < 767)
    {
 $('html, body').animate({
        scrollTop: $("form#contact_form").offset().top - 100
    }, 200);

    
    }else{
       $('html, body').animate({
        scrollTop: $("form#contact_form").offset().top - 200
    }, 200);
    }
      
    }

},100)
  })
  
}
function sendLinkToCustomer(){        
        var customerFormData = new FormData();
        customerFormData.append('email', $('#account-email').val());
        var AjaxUrl = "https://genieapi.thegenielab.com/send-activation-link-to-customer?shop=out-grow-llc.myshopify.com"
            $.ajax({
              type: 'POST',
              url: AjaxUrl,
              processData: false,
              contentType: false,
              data: customerFormData,      
              success: function(proResultData) { 
                if(proResultData.status==true){
                   $('#account-email').val('');  
                   $('.success-activation').show();
                   $('.errors-activation').hide();
                   $('.success-activation').html(proResultData.message);
                }else{
                  $('#account-email').val('');  
                  $('.success-activation').hide();
                  $('.errors-activation').show();
                  $('.errors-activation').html(proResultData.message);
                  setTimeout(function(){ $('.errors-activation').hide(); }, 6000);

                }      
              },
              error: function (err) {
              console.log(err);              
              }
            });       
           
}